import React from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import logoFullDark from '../../assets/brand/logo-full-dark.svg';
import logoFullLight from '../../assets/brand/logo-full.svg';
import logoIcon from '../../assets/brand/logo-icon.svg';

export type BrandLogoVariant = 'icon' | 'full';

export interface BrandLogoProps {
  variant?: BrandLogoVariant;
  /** Max height in px */
  height?: number;
  sx?: SxProps<Theme>;
  alt?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = 'full',
  height = variant === 'icon' ? 32 : 40,
  sx,
  alt = 'Cnapse Insight',
}) => {
  const muiTheme = useMuiTheme();
  const src =
    variant === 'icon'
      ? logoIcon
      : muiTheme.palette.mode === 'dark'
        ? logoFullDark
        : logoFullLight;

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        height,
        width: 'auto',
        maxWidth: variant === 'full' ? 280 : height,
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );
};

export default BrandLogo;
